<div id="loaderContainer" *ngIf="loading">
  <img loading="lazy" [id]="size" src="../../../assets/loading.svg" alt="loading" />
</div>
